import { render, staticRenderFns } from "./SearchResultsCategories.vue?vue&type=template&id=5c537551&scoped=true&"
import script from "./SearchResultsCategories.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsCategories.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsCategories.vue?vue&type=style&index=0&id=5c537551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c537551",
  null
  
)

export default component.exports